export class Client {
  public Ident: string;
  public RaisoCLI: string;
  public ListContact: Contact[];
}

/* ------------------------------------------------------ */

export class Contact {
  public Ident: string;
  public CivilPER: string;
  public Pre01PER: string;
  public NomfaPER: string;
  public NeproPER: string;
  public IsSelected: boolean;
}
